export default (price, language) => {
  return `${price} ${language === "bg" ? "лв." : "lev"}`;
};
